import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forum-add-feedlist',
  templateUrl: './forum-add-feedlist.component.html',
  styleUrls: ['./forum-add-feedlist.component.scss']
})
export class ForumAddFeedlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
